import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
// @mui
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  MenuItem,
  Theme,
  Typography,
} from "@mui/material";
import { alpha } from "@mui/material/styles";

import MenuPopover from "../../components/MenuPopover";

import { useAppDispatch, useCurrentUser } from "@hooks";
import { authRedux } from "@store";
import { confirm } from "@utils";

export default function AccountPopover() {
  const anchorRef = useRef(null);
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { displayName, email, avatar } = useCurrentUser();

  const [open, setOpen] = useState(null);

  const handleOpen = (event: any) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  const logout = async () => {
    handleClose();
    const confirm_value = await confirm(
      "Uyarı",
      "Çıkış yapmak istediğinizden emin misiniz?",
    );

    if (confirm_value) {
      dispatch(authRedux.logout());
      navigate("/login", { replace: true });
    }
  };

  const sxStyles = {
    p: 0,
    ...(open
      ? {
          "&:before": {
            zIndex: 1,
            content: "''",
            width: "100%",
            height: "100%",
            borderRadius: "50%",
            position: "absolute",
            bgcolor: (theme: Theme) => alpha(theme.palette.grey[900], 0.8),
          },
        }
      : {}),
  };

  return (
    <>
      <IconButton ref={anchorRef} onClick={handleOpen} sx={sxStyles}>
        <Avatar src={avatar} alt={displayName} sx={{ width: 40, height: 40 }}>
          {displayName.charAt(0).toUpperCase()}
        </Avatar>
      </IconButton>

      <MenuPopover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        sx={{
          p: 0,
          mt: 1.5,
          ml: 0.75,
          "& .MuiMenuItem-root": {
            typography: "body2",
            borderRadius: 0.75,
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {displayName}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem onClick={logout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </MenuPopover>
    </>
  );
}
